
export const PLAYING = 'playing';
export const LOADING = 'loading';
export const STOP = 'stop';
type Status =(typeof PLAYING | typeof LOADING | typeof STOP);




export default Status